/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResetPasswordDto } from '../../models/reset-password-dto';
import { ServerProblem } from '../../models/server-problem';

export interface SignUpControllerResetPassword$Params {
      body: ResetPasswordDto
}

export function signUpControllerResetPassword(http: HttpClient, rootUrl: string, params: SignUpControllerResetPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ServerProblem>>> {
  const rb = new RequestBuilder(rootUrl, signUpControllerResetPassword.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ServerProblem>>;
    })
  );
}

signUpControllerResetPassword.PATH = '/account/reset-password';
